import { render, staticRenderFns } from "./ChangeTemplate.vue?vue&type=template&id=12f5ba32&scoped=true&"
import script from "./ChangeTemplate.vue?vue&type=script&lang=js&"
export * from "./ChangeTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ChangeTemplate.vue?vue&type=style&index=0&id=12f5ba32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f5ba32",
  null
  
)

export default component.exports